import React from "react";
import { get } from "lodash";

import { getIcon } from "../../../helpers/icons";
import Link from "../../../components/Link";
import AsyncGet from "../../../components/Materials/AsyncGet";
import style from "./style.module.css";

const DeleteNotification = ({ item = {} }) => {
    return (
        <div className={style.closeWrapper}>
            <AsyncGet
                url={`/notification/${get(item, "id")}`}
                method="delete"
                loadOnMount={false}
                permissionText="Notification Delete"
                onFetch={({ data, deleteGridItems }) => {
                    if (get(data, "id")) {
                        deleteGridItems({ attribute: "NotificationList", data: [get(data, 'id')] });
                    }
                }}
                render={({ loadFromAPI }) => {
                    return (
                        <Link className={style.closeBtn}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                loadFromAPI();
                            }}>
                            <i className={getIcon("Close")} />
                        </Link>
                    )
                }}

            />
        </div>
    )
}

export default DeleteNotification;